import { defineRule } from '../rule.js';

/** E: two channels share a number. */
export const channelNumberDuplicate = defineRule(
  'channel-number-duplicate',
  'error',
  { en: 'Duplicate channel number', de: 'Kanalnummer doppelt' },
  (data, emit) => {
    const byNumber = new Map<number, string[]>();
    for (const ch of Object.values(data.channels)) {
      byNumber.set(ch.number, [...(byNumber.get(ch.number) ?? []), ch.id]);
    }
    return [...byNumber.entries()]
      .filter(([, ids]) => ids.length > 1)
      .map(([number, ids]) => emit(ids, { number }));
  },
);
